import { render, staticRenderFns } from "./BasicSettingsMapContent.vue?vue&type=template&id=126d8038&scoped=true&lang=html&"
import script from "./BasicSettingsMapContent.vue?vue&type=script&lang=js&"
export * from "./BasicSettingsMapContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126d8038",
  null
  
)

export default component.exports